// ─── Ticket Filter Types ──────────────────────────────────────────────────────

import { i18n } from "@tellescope/i18n";
import type { FreeformFieldOption, FreeformFilter } from "@tellescope/utils";

export type TicketStatusFilter = "open" | "closed" | "all";

export type TicketTagsBehavior = "match_all" | "match_any" | "match_none";

export interface TicketDateRangeFilter {
  from?: number;
  to?: number;
}

export interface TicketTagsFilter {
  tags: string[];
  behavior: TicketTagsBehavior;
}

export type TicketFreeformFilter = FreeformFilter;

export interface TicketFilters {
  status?: TicketStatusFilter;
  stages?: string[];
  ownerIds?: string[];
  dueDateRange?: TicketDateRangeFilter;
  closedDateRange?: TicketDateRangeFilter;
  tags?: TicketTagsFilter;
  freeform?: TicketFreeformFilter[];
}

// ─── Core ticket fields available for freeform filtering ─────────────────────

export const getTicketFreeformFieldOptions: () => FreeformFieldOption[] = () => [
  { value: "title", label: i18n.t("Title", { ns: "tickets" }), valueType: "string" },
  { value: "stage", label: i18n.t("Stage", { ns: "tickets" }), valueType: "string" },
  { value: "priority", label: i18n.t("Priority", { ns: "tickets" }), valueType: "number" },
  { value: "type", label: i18n.t("Type", { ns: "tickets" }), valueType: "string" },
  { value: "message", label: i18n.t("Message", { ns: "tickets" }), valueType: "string" },
  { value: "owner", label: i18n.t("Owner (ID)", { ns: "tickets" }), valueType: "string" },
  { value: "closedForReason", label: i18n.t("Closed For Reason", { ns: "tickets" }), valueType: "string" },
  { value: "source", label: i18n.t("Source", { ns: "tickets" }), valueType: "string" },
  { value: "externalId", label: i18n.t("External ID", { ns: "tickets" }), valueType: "string" },
  { value: "queueId", label: i18n.t("Queue ID", { ns: "tickets" }), valueType: "string" },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────

/** Returns true if two TicketFilters are deeply equal (for dirty checking) */
export const ticketFiltersAreEqual = (a: TicketFilters, b: TicketFilters): boolean => {
  return JSON.stringify(a) === JSON.stringify(b);
};
